module.exports = __webpack_public_path__ + "img/cos.3ce812d4.png";